import { render } from "./OnboardingPurpose.vue?vue&type=template&id=5f46992a"
import script from "./OnboardingPurpose.vue?vue&type=script&lang=js"
export * from "./OnboardingPurpose.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__